import { DisconnectReason } from 'livekit-client';

export const DISCONNECT_REASON_MAP: Record<DisconnectReason, string> = {
  [DisconnectReason.AGENT_ERROR]: 'Agent error',
  [DisconnectReason.CLIENT_INITIATED]: 'User initiated',
  [DisconnectReason.CONNECTION_TIMEOUT]: 'Connection timeout',
  [DisconnectReason.DUPLICATE_IDENTITY]: 'Duplicate identity',
  [DisconnectReason.JOIN_FAILURE]: 'Join failure',
  [DisconnectReason.MEDIA_FAILURE]: 'Media failure',
  [DisconnectReason.MIGRATION]: 'Migration',
  [DisconnectReason.PARTICIPANT_REMOVED]: 'Participant removed',
  [DisconnectReason.ROOM_CLOSED]: 'Room closed',
  [DisconnectReason.ROOM_DELETED]: 'Room deleted',
  [DisconnectReason.SERVER_SHUTDOWN]: 'Server shutdown',
  [DisconnectReason.SIGNAL_CLOSE]: 'Signal close',
  [DisconnectReason.SIP_TRUNK_FAILURE]: 'SIP trunk failure',
  [DisconnectReason.STATE_MISMATCH]: 'State mismatch',
  [DisconnectReason.UNKNOWN_REASON]: 'Unknown reason',
  [DisconnectReason.USER_REJECTED]: 'User rejected',
  [DisconnectReason.USER_UNAVAILABLE]: 'User unavailable',
};

export const DISCONNECT_REASON_LIST = Object.values(DISCONNECT_REASON_MAP);

export const VIDEO_SESSION_ACTIVE = 'video-session-active';
export const INTENTIONAL_LEAVE_PACKET_TYPE = 'INTENTIONAL_LEAVE';

export type NetworkQualityChange = {
  timestamp: number;
  providerQuality: string | null;
  clientQuality: string | null;
};

export const NETWORK_QUALITY_GRAPH_HEIGHT = 80;
export const NETWORK_QUALITY_GRAPH_WIDTH = 340;
export const NETWORK_QUALITY_ORDER = ['excellent', 'good', 'poor', 'lost', 'unknown'] as const;
export type NetworkQualityLevel = typeof NETWORK_QUALITY_ORDER[number];
export const NETWORK_QUALITY_LABEL: Record<string, string> = {
  excellent: 'Excellent',
  good: 'Good',
  poor: 'Poor',
  lost: 'Lost',
  unknown: 'Unknown',
};
export const NETWORK_QUALITY_COLOR: Record<string, string> = {
  excellent: '#2e7d32',
  good: '#558b2f',
  poor: '#e65100',
  lost: '#b71c1c',
  unknown: '#757575',
};
export const VIDEO_MESSAGING_UNREAD_EVENT = 'VideoMessagingUnread';
export type VideoOverlaySizing = 'compact' | 'sidebar' | 'fullscreen';
export const AINotesLabel = 'AI notes';
